import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';

type Props = {
  isOpen: boolean;
  items: [];
  onHide: () => void;
};

function UsersPreview({ isOpen, items, onHide }: Props) {
  return (
    <Dialog header="Assigned Users" onHide={onHide} visible={isOpen} modal>
      <DataTable value={items} rows={15} size="small" rowHover paginator>
        <Column header="Name" field="name" sortable />
        <Column header="Family Name" field="familyName" sortable />
        <Column header="Email" field="email" sortable />
      </DataTable>
    </Dialog>
  );
}

export default UsersPreview;
